import { ReactNode } from "react";

import useContextValues from "./Context/useContextValues";
import { BulkActionsApiContext, BulkActionsDataContext } from "./Context";
import { BulkActionsCloseMethod, BulkActionsVariant } from "./types";
import { BulkActionResultsStepContinueWith } from "./Drawer/ResultsStep/types";

type BulkActionsProps = {
  selectedItemsCount: number;
  children: ReactNode;
  onClose: (variant: BulkActionsVariant, method: BulkActionsCloseMethod) => void;
  onContinueWith: (continueWith: BulkActionResultsStepContinueWith) => void;
  isExecutingBulkActions: boolean;
  skipResults?: boolean;
};

const BulkActions = ({
  selectedItemsCount,
  children,
  onClose,
  onContinueWith,
  isExecutingBulkActions,
  skipResults,
}: BulkActionsProps) => {
  const { apiContext, dataContext } = useContextValues({
    selectedItemsCount,
    onClose,
    onContinueWith,
    isExecutingBulkActions,
    skipResults,
  });

  return (
    <BulkActionsApiContext.Provider value={apiContext}>
      <BulkActionsDataContext.Provider value={dataContext}>
        {children}
      </BulkActionsDataContext.Provider>
    </BulkActionsApiContext.Provider>
  );
};

export default BulkActions;
